module.exports = __webpack_public_path__ + "static/media/mc_open_vector.cf1c50ce.svg";